import React, { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import BasicButton from "../../BasicButton";
import UserLogo from "../../assets/logoAvatar.svg";
import styles from "./EditModalAdmin.module.scss";

interface Admin {
  role: "ADMIN" | "CLIENT";
  position: string;
  id?: string;
  __typename?: string;
  name: string;
  email: string;
  avatarUrl: string;
}

const EditModalAdmin: React.FC<{
  admin: Admin;
  onClose: () => void;
  onSave: (updatedAdmin: Admin) => Promise<void>;
  onDelete: () => void;
}> = ({ admin, onClose, onSave, onDelete }) => {
  const [editedAdmin, setEditedAdmin] = useState(admin);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setEditedAdmin((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.panel}>
        <div className={styles.header}>
          <h2 className={styles.title}>Edit</h2>
          <span className={styles.subtitle}>{admin.name}</span>
          <button
            type="button"
            onClick={onClose}
            className={styles.close}
            aria-label="Close"
          >
            <CloseOutlined />
          </button>
        </div>
        <img
          src={admin.avatarUrl || UserLogo}
          alt=""
          className={styles.avatar}
        />
        <label className={styles.field}>
          <span className={styles.label}>Name</span>
          <input
            type="text"
            name="name"
            value={editedAdmin.name}
            onChange={handleInputChange}
            className={styles.control}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Email</span>
          <input
            type="email"
            name="email"
            value={editedAdmin.email}
            onChange={handleInputChange}
            className={styles.control}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Job position</span>
          <input
            type="text"
            name="position"
            value={editedAdmin.position}
            onChange={handleInputChange}
            className={styles.control}
          />
        </label>
        <label className={styles.field}>
          <span className={styles.label}>Role</span>
          <select
            name="role"
            value={editedAdmin.role}
            onChange={handleInputChange}
            className={styles.control}
          >
            <option value="ADMIN">Admin</option>
            {/*<option value="CLIENT">User</option>*/}
          </select>
        </label>
        <BasicButton
          onClick={onDelete}
          title="Delete user"
          variant="danger"
          sx={{ width: "100%" }}
        />
        <div className={styles.footer}>
          <BasicButton
            onClick={onClose}
            title="Cancel"
            variant="secondary"
            sx={{ flex: 1 }}
          />
          <BasicButton
            onClick={() => onSave(editedAdmin)}
            title="Save"
            variant="primary"
            sx={{ flex: 1 }}
          />
        </div>
      </div>
    </div>
  );
};

export default EditModalAdmin;
